import {useConfig} from '@aboutyou/config';
import {GetRecommendationsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {BasketSection} from '@aboutyou/ui-components';
import React from 'react';
import {
  AddToBasketPayload,
  StreamProductTileDeprecated,
} from '../../../features/ProductStream/Tiles/StreamProductTileDeprecated';
import {RecommendationsLane} from '../../../features/Recommendations/deprecated/RecommendationsLane';

export interface RecommendationsViewProps {
  items: GetRecommendationsResponse[];
  onClickAddToBasket: (tile?: AddToBasketPayload) => void;
  compactMode?: boolean;
}

export const RecommendationsView: React.FC<RecommendationsViewProps> = ({
  items,
  onClickAddToBasket,
  compactMode,
}) => {
  const {t} = useTranslation();
  const {device} = useConfig();
  return (
    <>
      {items.map((item, idx) => {
        switch (item.recommendation?.type?.$case) {
          case 'products': {
            const {products, headline, subline, promotionTracking} =
              item.recommendation.type.products;

            return (
              <BasketSection>
                <RecommendationsLane
                  key={`producst-${idx}`}
                  compactMode={compactMode}
                  content={{
                    headline,
                    subline,
                  }}
                  streamPosition={idx}
                  promotionTracking={promotionTracking}
                  testid={`basketRecoLane-${idx}`}
                  productTileConfig={{
                    onClickAddCta: onClickAddToBasket
                      ? (tile?: AddToBasketPayload) => onClickAddToBasket(tile)
                      : undefined,
                    addCtaVisibility: 'always',
                    showLowestPriorPriceHint: true,
                    addCtaTitle: t('Add to basket'),
                    gridColumns: device === 'desktop' ? 4 : 2,
                  }}
                  ProductTileComponent={StreamProductTileDeprecated}
                  products={{
                    $case: 'list',
                    list: {
                      deprecatedProducts: products.products,
                      itemsPreferences: products.itemPreferences,
                    },
                  }}
                  forceCenterTitle
                />
              </BasketSection>
            );
          }
        }
        return null;
      })}
    </>
  );
};
